import React from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import LoadingSpinner from "../LoadingSpinner";

export default function CoachesWhoLikedDialog({
  open,
  onClose,
  userRole,
  loading,
  coaches,
  coachLikes = 0,
  adminLikes = 0,
  onDecrementAdminLike,
  decrementLoading = false,
}) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity"
      />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4 ">
        <DialogPanel
          className="w-full max-w-2xl max-h-full space-y-4 border bg-white rounded-lg p-6"
          onMouseDown={(e) => e.stopPropagation()}
        >
          <DialogTitle className="text-xl uppercase pb-0 font-bold">
            <div className="flex justify-between items-center mb-4">
              <h2>Coaches who liked your profile</h2>
              <button
                type="button"
                className="text-gray-500 hover:text-gray-700 text-lg"
                onClick={onClose}
              >
                ✕
              </button>
            </div>
          </DialogTitle>
          {userRole === "admin" && (
            <div className="max-h-screen overflow-x-hidden overflow-y-auto pr-3">
              {!loading && (
                <div className="flex items-center justify-between mb-3 pb-2 border-b">
                  <p className="text-sm text-gray-700">
                    {coachLikes + adminLikes} total — {coachLikes} coaches,{" "}
                    {adminLikes} staff
                  </p>
                  {adminLikes >= 1 && (
                    <button
                      type="button"
                      onClick={onDecrementAdminLike}
                      disabled={decrementLoading}
                      className="rounded-md border border-gray-300 px-2 py-1 text-xs text-gray-700 hover:bg-gray-50 disabled:opacity-50 shrink-0 ml-3"
                    >
                      Remove staff like
                    </button>
                  )}
                </div>
              )}
              {loading ? (
                <LoadingSpinner />
              ) : (
                <ul className="list-none p-0 mt-0 overflow-y-auto pr-3 -mr-4">
                  {coaches.map((coach, key) => (
                    <li key={key} className="p-2 border-b px-2 shrink-0">
                      <div className="flex justify-between items-center">
                        <div className="flex flex-row flex-1">
                          <div className="my-auto rounded-md">
                            <img
                              alt={coach.name}
                              src={
                                coach.profilePicture || "/default-coach-img.png"
                              }
                              className="grow-0 shrink-0 rounded-md h-[40px] w-[40px] "
                            />
                          </div>
                          <div className="ml-4">
                            <p className="text-md uppercase">{coach.name}</p>
                            <p className="text-sm text-gray-700">
                              {coach.university}
                            </p>
                          </div>
                        </div>
                        <div>
                          <p className="my-auto mt-2 text-sm text-gray-500">
                            {coach.likesDate}
                          </p>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}
        </DialogPanel>
      </div>
    </Dialog>
  );
}
